import { t } from 'i18next';
import { isDarkMode } from "./ThemeHelper";

export const FAN_BUDDY_MBTI = {
  INTJ: {
    name: t('ChatPage.fanBuddy.name.intj'),
    recap: t('ChatPage.fanBuddy.recap.intj'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.intj_1'),
      t('ChatPage.fanBuddy.descriptions.intj_2')
    ],
    compatibleRanking: [
      'ESFP',
      'ESTP',
      'ISFP',
      'INFP',
      'INFJ',
      'ENFP',
      'ENTP',
      'ISTP',
      'ENFJ',
      'INTJ',
      'ISTJ',
      'ENTJ',
      'INTP',
      'ESTJ',
      'ISFJ',
      'ESFJ'
    ],
    textColor: {
      primary: isDarkMode() ? '79, 70, 229' : '79, 70, 229',
      secondary: isDarkMode() ? '251, 191, 36' : '251, 191, 36'
    },
    backgroundColor: {
      primary: isDarkMode() ? '86, 85, 156' : '165, 163, 244',
      secondary: isDarkMode() ? '140, 119, 32' : '253, 230, 138'
    }
  },
  INTP: {
    name: t('ChatPage.fanBuddy.name.intp'),
    recap: t('ChatPage.fanBuddy.recap.intp'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.intp_1'),
      t('ChatPage.fanBuddy.descriptions.intp_2')
    ],
    compatibleRanking: [
      'ESFJ',
      'ENFJ',
      'ISFJ',
      'INFJ',
      'ESTJ',
      'ISTJ',
      'ENTJ',
      'ENFP',
      'ENTP',
      'INTP',
      'INTJ',
      'ISTP',
      'INFP',
      'ESTP',
      'ISFP',
      'ESFP'
    ],
    textColor: {
      primary: isDarkMode() ? '147, 51, 234' : '147, 51, 234',
      secondary: isDarkMode() ? '52, 211, 153' : '52, 211, 153'
    },
    backgroundColor: {
      primary: isDarkMode() ? '105, 64, 136' : '216, 180, 243',
      secondary: isDarkMode() ? '51, 159, 98' : '167, 243, 200'
    }
  },
  ENTJ: {
    name: t('ChatPage.fanBuddy.name.entj'),
    recap: t('ChatPage.fanBuddy.recap.entj'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.entj_1'),
      t('ChatPage.fanBuddy.descriptions.entj_2')
    ],
    compatibleRanking: [
      'ISFP',
      'INFP',
      'ESFP',
      'ESTP',
      'ISTP',
      'INTP',
      'ENFP',
      'INFJ',
      'INTJ',
      'ENFJ',
      'ISTJ',
      'ENTP',
      'ESTJ',
      'ENTJ',
      'ESFJ',
      'ISFJ'
    ],
    textColor: {
      primary: isDarkMode() ? '244, 63, 94' : '244, 63, 94',
      secondary: isDarkMode() ? '255, 214, 10' : '255, 214, 10'
    },
    backgroundColor: {
      primary: isDarkMode() ? '154, 107, 107' : '253, 176, 176',
      secondary: isDarkMode() ? '159, 135, 64' : '255, 229, 153'
    }
  },
  ENTP: {
    name: t('ChatPage.fanBuddy.name.entp'),
    recap: t('ChatPage.fanBuddy.recap.entp'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.entp_1'),
      t('ChatPage.fanBuddy.descriptions.entp_2')
    ],
    compatibleRanking: [
      'ISFJ',
      'ISTJ',
      'ENTP',
      'ESTJ',
      'ESFJ',
      'INFJ',
      'INTJ',
      'INFP',
      'ENFJ',
      'INTP',
      'ISTP',
      'ENFP',
      'ESTP',
      'ENTJ',
      'ESFP',
      'ISFP'
    ],
    textColor: {
      primary: isDarkMode() ? '16, 185, 129' : '16, 185, 129',
      secondary: isDarkMode() ? '245, 158, 11' : '245, 158, 11'
    },
    backgroundColor: {
      primary: isDarkMode() ? '63, 126, 97' : '167, 243, 208',
      secondary: isDarkMode() ? '146, 112, 53' : '253, 217, 155'
    }
  },
  INFJ: {
    name: t('ChatPage.fanBuddy.name.infj'),
    recap: t('ChatPage.fanBuddy.recap.infj'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.infj_1'),
      t('ChatPage.fanBuddy.descriptions.infj_2')
    ],
    compatibleRanking: [
      'ESTP',
      'ESFP',
      'ISTP',
      'INTP',
      'ENFP',
      'ENTP',
      'INTJ',
      'ENTJ',
      'INFJ',
      'ISFP',
      'ENFJ',
      'ESFJ',
      'ISFJ',
      'INFP',
      'ISTJ',
      'ESTJ'
    ],
    textColor: {
      primary: isDarkMode() ? '74, 222, 128' : '74, 222, 128',
      secondary: isDarkMode() ? '59, 130, 246' : '59, 130, 246'
    },
    backgroundColor: {
      primary: isDarkMode() ? '64, 112, 59' : '188, 244, 194',
      secondary: isDarkMode() ? '51, 100, 154' : '147, 197, 253'
    }
  },
  INFP: {
    name: t('ChatPage.fanBuddy.name.infp'),
    recap: t('ChatPage.fanBuddy.recap.infp'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.infp_1'),
      t('ChatPage.fanBuddy.descriptions.infp_2')
    ],
    compatibleRanking: [
      'ESTJ',
      'ENTJ',
      'INTJ',
      'ISTJ',
      'ENFJ',
      'ESFJ',
      'ENTP',
      'INFP',
      'ISFJ',
      'INTP',
      'ESFP',
      'ENFP',
      'ISFP',
      'INFJ',
      'ISTP',
      'ESTP'
    ],
    textColor: {
      primary: isDarkMode() ? '167, 139, 250' : '167, 139, 250',
      secondary: isDarkMode() ? '251, 191, 36' : '251, 191, 36'
    },
    backgroundColor: {
      primary: isDarkMode() ? '83, 69, 150' : '221, 214, 254',
      secondary: isDarkMode() ? '141, 123, 53' : '253, 230, 138'
    }
  },
  ENFJ: {
    name: t('ChatPage.fanBuddy.name.enfj'),
    recap: t('ChatPage.fanBuddy.recap.enfj'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.enfj_1'),
      t('ChatPage.fanBuddy.descriptions.enfj_2')
    ],
    compatibleRanking: [
      'ISTP',
      'INTP',
      'ESTP',
      'ESFP',
      'ENFJ',
      'INFP',
      'ISFP',
      'ENTP',
      'INTJ',
      'ESFJ',
      'INFJ',
      'ENFP',
      'ENTJ',
      'ISFJ',
      'ESTJ',
      'ISTJ'
    ],
    textColor: {
      primary: isDarkMode() ? '38, 171, 127' : '38, 171, 127',
      secondary: isDarkMode() ? '255, 109, 0' : '255, 109, 0'
    },
    backgroundColor: {
      primary: isDarkMode() ? '56, 140, 105' : '157, 236, 203',
      secondary: isDarkMode() ? '147, 111, 86' : '255, 194, 153'
    }
  },
  ENFP: {
    name: t('ChatPage.fanBuddy.name.enfp'),
    recap: t('ChatPage.fanBuddy.recap.enfp'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.enfp_1'),
      t('ChatPage.fanBuddy.descriptions.enfp_2')
    ],
    compatibleRanking: [
      'ISTJ',
      'ISFJ',
      'ESFJ',
      'ESTJ',
      'INFJ',
      'INTJ',
      'ENTJ',
      'ISFP',
      'ENFP',
      'INTP',
      'INFP',
      'ENFJ',
      'ENTP',
      'ESFP',
      'ESTP',
      'ISTP'
    ],
    textColor: {
      primary: isDarkMode() ? '255, 113, 113' : '255, 113, 113',
      secondary: isDarkMode() ? '59, 130, 246' : '59, 130, 246'
    },
    backgroundColor: {
      primary: isDarkMode() ? '147, 95, 95' : '255, 195, 195',
      secondary: isDarkMode() ? '59, 97 140' : '147, 197, 253'
    }
  },
  ISTJ: {
    name: t('ChatPage.fanBuddy.name.istj'),
    recap: t('ChatPage.fanBuddy.recap.istj'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.istj_1'),
      t('ChatPage.fanBuddy.descriptions.istj_2')
    ],
    compatibleRanking: [
      'ENFP',
      'ENTP',
      'ISFP',
      'INFP',
      'ESTP',
      'ESFP',
      'INTP',
      'ESTJ',
      'ESFJ',
      'ISTJ',
      'INTJ',
      'ISFJ',
      'ISTP',
      'ENTJ',
      'INFJ',
      'ENFJ'
    ],
    textColor: {
      primary: isDarkMode() ? '37, 99, 235' : '37, 99, 235',
      secondary: isDarkMode() ? '250, 204, 21' : '250, 204, 21'
    },
    backgroundColor: {
      primary: isDarkMode() ? '62, 97, 146' : '163, 200, 253',
      secondary: isDarkMode() ? '159, 134, 64' : '255, 224, 138'
    }
  },
  ISFJ: {
    name: t('ChatPage.fanBuddy.name.isfj'),
    recap: t('ChatPage.fanBuddy.recap.isfj'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.isfj_1'),
      t('ChatPage.fanBuddy.descriptions.isfj_2')
    ],
    compatibleRanking: [
      'ENTP',
      'ENFP',
      'INTP',
      'ISTP',
      'ESFP',
      'ESTP',
      'ESTJ',
      'INFP',
      'ESFJ',
      'ISTJ',
      'ISFJ',
      'ENFJ',
      'INFJ',
      'ISFP',
      'INTJ',
      'ENTJ'
    ],
    textColor: {
      primary: isDarkMode() ? '34, 211, 238' : '34, 211, 238',
      secondary: isDarkMode() ? '248, 113, 113' : '248, 113, 113'
    },
    backgroundColor: {
      primary: isDarkMode() ? '85, 125, 88' : '165, 239, 250',
      secondary: isDarkMode() ? '124, 85, 85' : '253, 195, 195'
    }
  },
  ESTJ: {
    name: t('ChatPage.fanBuddy.name.estj'),
    recap: t('ChatPage.fanBuddy.recap.estj'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.estj_1'),
      t('ChatPage.fanBuddy.descriptions.estj_2')
    ],
    compatibleRanking: [
      'INFP',
      'ISFP',
      'INTP',
      'ENTP',
      'ISTP',
      'ESFP',
      'ENFP',
      'ISTJ',
      'ISFJ',
      'ESTJ',
      'ESFJ',
      'INTJ',
      'ENTJ',
      'ESTP',
      'ENFJ',
      'INFJ'
    ],
    textColor: {
      primary: isDarkMode() ? '59, 130, 246' : '59, 130, 246',
      secondary: isDarkMode() ? '249, 115, 22' : '249, 115, 22'
    },
    backgroundColor: {
      primary: isDarkMode() ? '90, 121, 156' : '147, 197, 253',
      secondary: isDarkMode() ? '161, 126, 96' : '252, 200, 154'
    }
  },
  ESFJ: {
    name: t('ChatPage.fanBuddy.name.esfj'),
    recap: t('ChatPage.fanBuddy.recap.esfj'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.esfj_1'),
      t('ChatPage.fanBuddy.descriptions.esfj_2')
    ],
    compatibleRanking: [
      'INTP',
      'ISTP',
      'ENTP',
      'ENFP',
      'INFP',
      'ISTJ',
      'ESFJ',
      'ESTP',
      'ISFP',
      'ENFJ',
      'ISFJ',
      'INFJ',
      'ESTJ',
      'ESFP',
      'ENTJ',
      'INTJ'
    ],
    textColor: {
      primary: isDarkMode() ? '251, 191, 36' : '251, 191, 36',
      secondary: isDarkMode() ? '168, 85, 247' : '168, 85, 247'
    },
    backgroundColor: {
      primary: isDarkMode() ? '141, 127, 73' : '253, 230, 138',
      secondary: isDarkMode() ? '91, 60, 115' : '216, 180, 243'
    }
  },
  ISTP: {
    name: t('ChatPage.fanBuddy.name.istp'),
    recap: t('ChatPage.fanBuddy.recap.istp'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.istp_1'),
      t('ChatPage.fanBuddy.descriptions.istp_2')
    ],
    compatibleRanking: [
      'ENFJ',
      'ESFJ',
      'INFJ',
      'ISFJ',
      'ENTJ',
      'ESTJ',
      'ESFP',
      'ESTP',
      'INTJ',
      'ISTP',
      'INTP',
      'ENTP',
      'ISTJ',
      'ISFP',
      'INFP',
      'ENFP'
    ],
    textColor: {
      primary: isDarkMode() ? '16, 185, 129' : '16, 185, 129',
      secondary: isDarkMode() ? '244, 63, 94' : '244, 63, 94'
    },
    backgroundColor: {
      primary: isDarkMode() ? '75, 137, 109' : '167, 243, 208',
      secondary: isDarkMode() ? '141, 91, 91' : '253, 176, 176'
    }
  },
  ISFP: {
    name: t('ChatPage.fanBuddy.name.isfp'),
    recap: t('ChatPage.fanBuddy.recap.isfp'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.isfp_1'),
      t('ChatPage.fanBuddy.descriptions.isfp_2')
    ],
    compatibleRanking: [
      'ENTJ',
      'ESTJ',
      'INTJ',
      'ISTJ',
      'ENFJ',
      'ESFJ',
      'INFJ',
      'ESFP',
      'ISFP',
      'ESTP',
      'ENFP',
      'INFP',
      'ISTP',
      'ISFJ',
      'INTP',
      'ENTP'
    ],
    textColor: {
      primary: isDarkMode() ? '192, 132, 252' : '192, 132, 252',
      secondary: isDarkMode() ? '255, 214, 10' : '255, 214, 10'
    },
    backgroundColor: {
      primary: isDarkMode() ? '112, 92, 132' : '235, 217, 254',
      secondary: isDarkMode() ? '153, 136, 87' : '255, 229, 153'
    }
  },
  ESTP: {
    name: t('ChatPage.fanBuddy.name.estp'),
    recap: t('ChatPage.fanBuddy.recap.estp'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.estp_1'),
      t('ChatPage.fanBuddy.descriptions.estp_2')
    ],
    compatibleRanking: [
      'INFJ',
      'INTJ',
      'ENFJ',
      'ENTJ',
      'ISFJ',
      'ISTP',
      'ISTJ',
      'ESFJ',
      'ESTP',
      'ISFP',
      'ESFP',
      'INTP',
      'ENTP',
      'ESTJ',
      'ENFP',
      'INFP'
    ],
    textColor: {
      primary: isDarkMode() ? '244, 63, 94' : '244, 63, 94',
      secondary: isDarkMode() ? '52, 211, 153' : '52, 211, 153'
    },
    backgroundColor: {
      primary: isDarkMode() ? '139, 87, 87' : '253, 176, 176',
      secondary: isDarkMode() ? '71, 147, 104' : '167, 243, 200'
    }
  },
  ESFP: {
    name: t('ChatPage.fanBuddy.name.esfp'),
    recap: t('ChatPage.fanBuddy.recap.esfp'),
    descriptions: [
      t('ChatPage.fanBuddy.descriptions.esfp_1'),
      t('ChatPage.fanBuddy.descriptions.esfp_2')
    ],
    compatibleRanking: [
      'INTJ',
      'INFJ',
      'ENTJ',
      'ENFJ',
      'ESTJ',
      'ISTJ',
      'ISFJ',
      'ISFP',
      'ISTP',
      'INFP',
      'ESFP',
      'ESTP',
      'ESFJ',
      'ENFP',
      'ENTP',
      'INTP'
    ],
    textColor: {
      primary: isDarkMode() ? '250, 204, 21' : '250, 204, 21',
      secondary: isDarkMode() ? '96, 165, 250' : '96, 165, 250'
    },
    backgroundColor: {
      primary: isDarkMode() ? '154, 135, 82' : '255, 224, 138',
      secondary: isDarkMode() ? '81, 129, 157' : '189, 230, 254'
    }
  }
};

export const KEYWORDS = [
  { key: 'morning_person', value: t('ChatPage.fanBuddy.keywords.morning_person') },
  { key: 'unique_taste', value: t('ChatPage.fanBuddy.keywords.unique_taste') },
  {
    key: 'public_transport_enthusiast',
    value: t('ChatPage.fanBuddy.keywords.public_transport_enthusiast')
  },
  { key: 'foodie', value: t('ChatPage.fanBuddy.keywords.foodie') },
  { key: 'contact_addict', value: t('ChatPage.fanBuddy.keywords.contact_addict') },
  { key: 'hate_phone', value: t('ChatPage.fanBuddy.keywords.hate_phone') },
  { key: 'animal_lover', value: t('ChatPage.fanBuddy.keywords.animal_lover') },
  { key: 'environmentalist', value: t('ChatPage.fanBuddy.keywords.environmentalist') },
  { key: 'feminism', value: t('ChatPage.fanBuddy.keywords.feminism') },
  { key: 'travel_enthusiast', value: t('ChatPage.fanBuddy.keywords.travel_enthusiast') },
  { key: 'non_alcoholic', value: t('ChatPage.fanBuddy.keywords.non_alcoholic') },
  { key: 'good_at_handicrafts', value: t('ChatPage.fanBuddy.keywords.good_at_handicrafts') },
  { key: 'twitter_instead_of_x', value: t('ChatPage.fanBuddy.keywords.twitter_instead_of_x') },
  { key: 'meme_genius', value: t('ChatPage.fanBuddy.keywords.meme_genius') },
  { key: 'obsessive_fan', value: t('ChatPage.fanBuddy.keywords.obsessive_fan') },
  { key: 'delulu_fan', value: t('ChatPage.fanBuddy.keywords.delulu_fan') }
];

export const getCompatibleMBTI = (mbti) => {
  return FAN_BUDDY_MBTI[mbti].compatibleRanking.slice(0, 2)
}

export const getIncompatibleMBTI = (mbti) => {
  return FAN_BUDDY_MBTI[mbti].compatibleRanking.slice(-2)
}
